import Chart from "../../../../src/client/katnh/interactions/chart/Chart.js";
import DvtBeen from "../../../../src/client/katnh/diagnostische-strategie-bij-verdenking-diepe-veneuze-trombose-van-het-been.json";
import * as React from 'react';
export default {
  Chart,
  DvtBeen,
  React
};